import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Badge, Collapse, List, ListItemButton } from '@mui/material'
import { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

interface AppMenuSubMenuItemProps {
  title: string
  items: { to: string; label: string }[]
  onCloseMenu: () => void
}

export function AppMenuSubMenuItem({ title, items, onCloseMenu }: AppMenuSubMenuItemProps) {
  const [open, setOpen] = useState(false)
  const location = useLocation()

  const handleToggle = () => {
    setOpen(prev => !prev)
  }

  return (
    <>
      <ListItemButton
        onClick={handleToggle}
        sx={{
          color: '#fff',
          fontWeight: 'bold',
          marginLeft: '40px',
          borderRadius: '25px 0px 0px 25px',
          paddingY: '12px',
          paddingLeft: '40px',
          '&.active, &.active:hover, :hover': {
            backgroundColor: '#fff',
            color: '#000'
          }
        }}
      >
        <Badge color='error'>{title}</Badge>
        {open ? <ExpandLess sx={{ marginLeft: 'auto' }} /> : <ExpandMore sx={{ marginLeft: 'auto' }} />}
      </ListItemButton>
      <Collapse in={open} timeout='auto' unmountOnExit>
        <List component='div' disablePadding>
          {items.map(item => (
            <ListItemButton
              key={item.to}
              component={NavLink}
              to={item.to}
              onClick={onCloseMenu}
              selected={location.pathname.endsWith(item.to)}
              sx={{
                color: '#fff',
                fontWeight: 'bold',
                marginLeft: '40px', // Indented for submenu
                borderRadius: '25px 0px 0px 25px',
                paddingY: '8px',
                paddingLeft: '40px',
                fontSize: '0.75rem',
                '&.active, &.active:hover, :hover': {
                  backgroundColor: '#fff',
                  color: '#000'
                },
                '&::before': {
                  content: '"•"',
                  display: 'inline-block',
                  marginRight: '8px',
                  color: '#fff'
                }
              }}
            >
              {item.label}
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  )
}
